// extracted by mini-css-extract-plugin
module.exports = {"container":"TaggedText-module__container--MJ5Jk","text":"TaggedText-module__text--y6oW0","tag":"TaggedText-module__tag--2TntY"};